import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./WordpressFixes.css";
import { DisplayMode, SortMode } from "./types";
import { get_source } from "./lib/source";
import {
  getListingFromURL,
  getDisplayModeFromURL,
  getSortFromURL,
  dd,
  getShareLinkFromURL,
  getSinglePropertyShareLinkFromURL,
} from "./Utils";
import Property from "./Property";
import Listings from "./Listings";
import SharedListings from "./SharedListings";
import StagingBanner from "./StagingBanner";
import { WORKER_BASE_URL } from "./constants";
import { initGlobalState } from "./CrappyGlobalState";
import { PropertySource } from "./lib/source";

function place_api() {
  const SCRIPT_ID: string = 'evapi_place_js';
  if(document.getElementById(SCRIPT_ID)){
    return;
  }
  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src =
    "https://event-application.null-988.workers.dev/assets/js/evapi.js?rt=ahNin1uiTee3Gidoo6kee0aicuk1de1pheiChah6wooqu1biep2nee3ohyeimieg";
  document.body.appendChild(script);
}
function place_youtube_button_lib(){
  const SCRIPT_ID: string = 'assets_lombardo_button_lib';
  if(document.getElementById(SCRIPT_ID)){
    return;
  }
  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  const u: URL = new URL('https://assets-lombardo.bnull.net/');
  u.pathname = '/fixed-youtube-video.js';
  u.searchParams.set('cacheBuster',String(Date.now()) + String(Math.random()));
  script.src = u.toString();
  script.type = 'text/javascript';
  script.defer = true;
  document.body.appendChild(script);
}
async function gotoSinglePropertyPage(id: string) {
  dd('gotoSinglePropertyPage',id);
  try {
    const u: URL = new URL(WORKER_BASE_URL);
    u.pathname = '/api/v1/lombardo/single-property-link';
    u.searchParams.set('id',id);
    const resp = await fetch(u,{
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(async (response: Response) => {
      return await response.json();
    }).catch((reason) => {
      console.error(`gotoSinglePropertyPage failed with:`, {reason});
      return null;
    });
    if(typeof resp?.property_id !== 'undefined'){
      const url: URL = new URL(window.location.href);
      const sort_mode: string = url.searchParams.get("sortMode") ?? "newest";
      const safe_url: URL = new URL(window.location.href);
      const is_staging: boolean = url.pathname.includes('/staging/');
      if(is_staging){
        safe_url.pathname = '/staging/';
      }else{
        safe_url.pathname = "/mls-properties/";
      }
      safe_url.searchParams.set("displayMode", 'property');
      safe_url.searchParams.set("sortMode", sort_mode);
      safe_url.searchParams.delete("backDisplayMode");
      safe_url.searchParams.set('listing',resp.property_id.replace(/[^KEY0-9]+/gi,''));
      window.location.href = safe_url.toString();
    }
  }catch(err){
    throw err;
  }
}
function App() {
  const [propertyID, setPropertyID] = React.useState<string | null>(null);
  const [displayMode, setDisplayMode] =
    React.useState<DisplayMode>("show-active");
  const [sortMode, setSortMode] = React.useState<SortMode>("newest");
  const [showThumbnails, setShowThumbnails] = React.useState<boolean>(true);
  const [isShareMode,setIsShareMode] = React.useState<boolean>(false);
  const [shareId,setShareId] = React.useState<number|undefined>(undefined);
  const [processingSinglePropertPage,setProcessingSinglePropertyPage] = React.useState<boolean>(false);
  const [source, setSource] = React.useState<PropertySource>('onekey');

  React.useEffect(() => {
    let s = get_source();
    setSource(s);
    dd("init");
    initGlobalState();
    dd("place");
    place_api();
    dd('place yt btn');
    place_youtube_button_lib();
    const single_property_share_id: number|undefined = getSinglePropertyShareLinkFromURL();
    if(single_property_share_id && !processingSinglePropertPage){
      dd("single_psi");
      setProcessingSinglePropertyPage(true);
      gotoSinglePropertyPage(String(single_property_share_id)).then(() => {
        setProcessingSinglePropertyPage(false);
      }).catch((reason) => {
        console.error('useEffect gotoSinglePropertyPage failed with:',reason);
      });
      return;
    }
    dd('gsl');
    const share_id: number|undefined = getShareLinkFromURL();
    setShareId(share_id);
    dd('setshare');
    if(share_id === undefined){
      setIsShareMode(false);
    }else{
      setIsShareMode(true);
    }
    const key: string | null = getListingFromURL();
    dd('key:',{key});
    if (key) {
      setPropertyID(key);
    }
    dd('gsfrom url',getSortFromURL());
    setSortMode(getSortFromURL());
    const mode: DisplayMode | null = getDisplayModeFromURL();
    dd({mode});
    if (!mode) {
      setDisplayMode("show-active");
    } else {
      setDisplayMode(mode);
    }
    setShowThumbnails(
      ["show-all", "show-sold", "show-active"].includes(displayMode)
    );
    dd({ displayMode },' displayMode');
  }, []);
  return (
    <div className="MasterContainer">
      {isShareMode && typeof shareId !== 'undefined' && (
        <SharedListings share_id={shareId} />
      )}
      {!isShareMode && showThumbnails && (
        <Listings display_mode={displayMode} sort_mode={sortMode} />
      )}
      {!isShareMode && propertyID !== null && displayMode === "property" && (
        <Property property_id={propertyID} />
      )}
      <StagingBanner/>
      <style>
        {`@media print {
      .no-print {
display: none !important;
}
.MasterContainer {
position: absolute !important;
left: 0px !important;
top: 0px !important;
padding: 0em !important;
}
header.site-header {
display: none !important;
}
.App .content-area > div {
position: absolute !important;
left: 0px !important;
top: 0px !important;
padding: 0em !important;
}
}`}
      </style>
    </div>
  );
}

export default App;
